import { Injectable } from "@angular/core";
import { UrlService } from "src/app/shared/services/url/url.service";
import { AppConfigService } from "src/app/core/config/config.service";
import { environment } from "src/environments/environment";
import {
  CustomerUri,
  FinanceUri,
  locationUri,
  ReportstUri,
  PromotionsUri,
  DailyLimitUri
} from "src/app/core/config/config.model";
import { CategoriesUri } from "../../../core/config/config.model";

@Injectable({ providedIn: "root" })
export class DashboardUriService {
  private baseUrl: string;
  private baseUrlTwo:string;
  private customerUri: CustomerUri;
  private locationUri: locationUri;
  private reportsUri: ReportstUri;
  private categoriesUri: CategoriesUri;
  private financeUri: FinanceUri;
  private promotionsUri: PromotionsUri;
  private dailyLimitUri:DailyLimitUri;
  constructor(
    private urlService: UrlService,
    private apiConfig: AppConfigService
  ) {
    this.baseUrl = environment.baseUrl;
    this.baseUrlTwo =environment.baseUrlTwo;
    this.customerUri = apiConfig.appConfig.customerUri;
    this.locationUri = apiConfig.appConfig.locationUri;
    this.reportsUri = apiConfig.appConfig.reportsUri;
    this.categoriesUri = apiConfig.appConfig.categoriesUri;
    this.financeUri = apiConfig.appConfig.financeUri;
    this.promotionsUri = apiConfig.appConfig.promotionsUri;
    this.dailyLimitUri= apiConfig.appConfig.dailyLimitUri
  }

  getPinsUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.customer_pins
    );
  }

  getMerchantListUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants
    );
  }

  getMerchantUri(id: number) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants,
      id.toString()
    );
  }

  getAddTerminalUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants,
      this.customerUri.add_terminal
    );
  }

  getUpdateTerminalUri(id: number) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants,
      id.toString(),
      this.customerUri.update_terminal
    );
  }

  getInviteMerchantUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants,
      this.customerUri.invite_merchant
    );
  }

  getResendInvitationMerchantUri(id: number) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants,
      id,
      this.customerUri.resend_code
    );
  }

  getConnectAccountToTerminalUri(id: number) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants,
      id,
      this.customerUri.connect_account
    );
  }

  // change to customer
  getUserUpdateProfileUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.profile
    );
  }

  getUserProfileByIdUri(id) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.my_customers,
      id
    );
  }

  getUserProfileUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.user_profile
    );
  }

  getCompanyProfileUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.profile
    );
  }

  getAddPinUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.customer_pins
    );
  }

  checkPinUsernameUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.customer_pins,
      this.customerUri.check_username
    );
  }

  setPinCredentialsUri(id) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.customer_pins,
      id,
      this.customerUri.set_credentials
    );
  }

  getUpdatePinUri(id: number) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.customer_pins,
      id
    );
  }

  getUpdatePinPasswordUri(id: number, sub: boolean) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.customer_pins,
      id,
      sub ? this.customerUri.change_password : this.customerUri.set_password
    );
  }

  getTimeZoneListUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.timezones
    );
  }

  getCountryListUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.locationUri.locations,
      this.locationUri.country
    );
  }

  getStateListUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.locationUri.locations,
      this.locationUri.state
    );
  }

  getCityListUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.locationUri.locations,
      this.locationUri.city
    );
  }

  getChangeUserPasswordUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.change_password
    );
  }

  getUploadUserDocumentUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.profile_documents
    );
  }

  getUploadCustomerDocumentUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.customerUri.profile_documents
    );
  }

  getCustomerDocumentUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.customerUri.profile_documents
    );
  }

  getUpdateCustomerDocumentUri(id) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.customerUri.profile_documents,
      id
    );
  }

  getDownloadCustomerDocumentUri(id) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.customerUri.profile_documents,
      id,
      this.customerUri.download
    );
  }

  getUpdateUserDocumentUri(id) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.profile_documents,
      id
    );
  }

  getDownloadUserDocumentUri(id) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.profile_documents,
      id,
      this.customerUri.download
    );
  }

  getGoogleTwoStepUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.two_step_verification
    );
  }

  getEmailTwoStepUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.email_two_step_verification
    );
  }

  getLoginTwoStepVerificationUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.login_two_step_verification
    );
  }

  getLoginTwoStepVerificationAddPhoneNumberUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.two_step_phone_number,
      this.customerUri.set_phone_number
    );
  }

  getLoginTwoStepVerificationConfirmPhoneNumberUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.two_step_phone_number,
      this.customerUri.confirm_phone_number
    );
  }

  getLoginTwoStepVerificationDeleteUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.delete_two_step
    );
  }

  getLoginTwoStepVerificationDetailUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.two_step_verification_login
    );
  }

  getRemoveSubUserAuthenticationUri(id) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.customer_pins,
      id,
      this.customerUri.remove_google_two_factor
    );
  }

  getCatalogLinksUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.categoriesUri.cards,
      this.categoriesUri.catalog_links
    );
  }

  getCheckCatalogNameUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.categoriesUri.cards,
      this.categoriesUri.catalog_links,
      this.categoriesUri.check_name
    );
  }

  getCatalogLinkUri(id) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.categoriesUri.cards,
      this.categoriesUri.catalog_links,
      id
    );
  }

  getCurrenciesUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.financeUri.finance,
      this.financeUri.currency
    );
  }

  getWalletBalanceNotificationUri(id?) {
    const url = [
      this.baseUrl,
      this.financeUri.finance,
      this.financeUri.wallet_balance_notification,
    ];
    if (id) {
      url.push(id);
    }
    return this.urlService.combineUri(...url);
  }

  generatePhoneVerifyCodeUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.phone_number_confirmation
    );
  }

  getApiAccessListUrl(id?: number) {
    // const url = [   // const url = [
    //   this.baseUrl,
    //   this.customerUri.customers,
    //   this.customerUri.api_config,
    // ];

    const url = [
      this.baseUrlTwo,
      this.customerUri.customers,
      this.customerUri.api_accesses,
    ];

    if (id) {
      url.push(id.toString());
    }

    return this.urlService.combineUri(...url);
  }

  getApiAccessUpdateUrl(id?: number) {
    // const url = [
    //   this.baseUrl,
    //   this.customerUri.customers,
    //   this.customerUri.api_config,
    // ];

    const url = [
      this.baseUrlTwo,
      this.customerUri.customers,
      this.customerUri.api_access,
    ];

    if (id) {
      url.push(id.toString());
    }

    return this.urlService.combineUri(...url);
  }

  getApiAccessRevokeUrl(id: number) {
    const url = [
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.api_config,
      id.toString(),
      this.customerUri.generate_secret_key,
    ];

    return this.urlService.combineUri(...url);
  }

  getPromotionsListUrl() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.promotionsUri.promotions
    );
  }

  getAdminPromotionsListUrl() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.promotionsUri.adminPromotions
    );
  }

  createPromotionUrl() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.promotionsUri.adminPromotions
    );
  }

  updatePromotionUrl(id) {
    return this.urlService.combineUri(
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.promotionsUri.adminPromotions,
      id.toString()
    );
  }

  getPromotionsDetail(id: number) {
    const url = [
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.promotionsUri.adminPromotions,
      id.toString(),
    ];

    return this.urlService.combineUri(...url);
  }

  listDailyLimitByAdmin(){
    const url = [
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.dailyLimitUri.adminDailyLimit,
    ];

    return this.urlService.combineUri(...url);
  }

  updateDailyLimitByAdmin(id){
    const url = [
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.dailyLimitUri.adminDailyLimit,
      id.toString()
    ];

    return this.urlService.combineUri(...url);
  }

  createDailyLimitByAdmin(){
    const url = [
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.dailyLimitUri.adminDailyLimit,
    ];

    return this.urlService.combineUri(...url);
  }

  resetDailyLimitByAdmin(id){
    const url = [
      this.baseUrl,
      this.reportsUri.reports,
      this.reportsUri.panel,
      this.dailyLimitUri.adminDailyLimit,
      id.toString()
    ];

    return this.urlService.combineUri(...url);
  }

  dailyLimitListPerCompany(){
    const url = [
      this.baseUrlTwo,
      this.customerUri.customers,
      this.dailyLimitUri.dailyLimit,

    ];

    return this.urlService.combineUri(...url);
  }

  updateDailyLimitForUser(id){
    const url = [
      this.baseUrlTwo,
      this.customerUri.customers,
      this.dailyLimitUri.dailyLimit,
      id.toString()
    ];

    return this.urlService.combineUri(...url);
  }

  createDailyLimitForUser(){
    const url = [
      this.baseUrlTwo,
      this.customerUri.customers,
      this.dailyLimitUri.dailyLimit,
    ];

    return this.urlService.combineUri(...url);
  }
}
